<div class="main-content header-cont">

  <!-- HEADER -->
  <div class="header" style="margin-left: 40px;">

    <!-- Body -->
    <div class="header-body header-body-custom">
      <div class="row align-items-end">
        <div class="col">

          <!-- Title -->
          <h1 class="header-title">
            <span>{{api.pageTitle}}</span>
          </h1>

        </div>
        <div class="col-auto valve-space">

          <div [ngSwitch]="isValveOpen" class="valve-style">
              <!-- <img src="assets/img/Valve_open.png" *ngSwitchCase="true" width="30" alt="Ventil ist offen"> -->
              <!-- <img src="assets/img/Valve_closed.png" *ngSwitchCase="false" width="30" alt="Ventil ist geschlossen"> -->
              <img src="assets/img/Valve_opened.png" width="26" *ngSwitchCase="true" alt="Ventil ist offen">
              <img src="assets/img/Valve_closed.png" width="26" *ngSwitchCase="false" alt="Ventil ist geschlossen">
          </div>

        </div>
        <div class="col-auto mr-4">
          <div class="notification-round">
            <a title="Benachrichtigungen" (click)="onClickOpenNotification()" href="javascript:void(0);">
              <span class="icon">
                <i class="fe fe-bell mr-2" style="font-size: 16px"></i>
              </span>
            </a>
          </div>
        </div>
      </div> <!-- / .row -->
    </div> <!-- / .header-body -->

  </div> <!-- / .header -->
</div> <!-- / .main-content -->

<!-- Notification modal -->
<ng-template #notificationModal let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h2 class="modal-title">Neue Benachrichtigungen</h2>
    <button type="button" class="close" aria-label="Close" (click)="closeNotificationModel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div *ngIf="!hasNotifications">
          <p>Derzeit liegen keine aktiven Alarme oder Meldungen vor</p>
        </div>

        <!-- Alarm notifications -->
        <div *ngIf="hasNotifications && notifications && notifications.length" class="table-responsive">
          <div class="col-12">
            <h4>Erkennung von Mikroleckagen</h4>
            <hr />
          </div>
          <table class="table">
            <thead>
              <th>Datum</th>
              <th>Meldung</th>
            </thead>
            <tbody>
              <tr *ngFor="let n of notifications" class="bg-white">
                <td placement="top" container="body" ngbTooltip="{{n.Timestamp | dateFormat }}"
                  class="pd-6px">
                  {{n.Timestamp | humanizedDate }}
                </td>
                <td class="pd-6px">{{ n.Content }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Normal notifications -->
        <div *ngIf="hasNotifications && userNotifications && userNotifications.length" class="table-responsive">
          <div class="col-12">
            <h4>Benachrichtigungen</h4>
            <hr />
          </div>
          <table class="table">
            <thead>
              <th>Datum</th>
              <th>Nachricht</th>
            </thead>
            <tbody>
              <tr *ngFor="let n of userNotifications" class="bg-white">
                <td placement="top" container="body" ngbTooltip="{{n.Timestamp | dateFormat }}"
                  class="pd-6px">
                  {{n.Timestamp | humanizedDate }}
                </td>
                <td class="pd-6px">{{ n.Content }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="closeNotificationModel()">Schließen</button>
  </div>

</ng-template>